import React, { useEffect, useRef } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as ArrowRightIcon } from "@/common/Images/ArrowRightIcon.svg";
import { callBrowser } from "../../nativebridge/JsToNative";
import { COMMON_UTIL } from "@/common/util/common.util";

const TermsBox = styled(Box)`
  width: 100%;
  & p {
    white-space: pre-wrap;
  }
`;

const TermsHeader = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const TermsHeaderTitle = styled(Typography)`
  &.MuiTypography-root {
    font-weight: 700;
    color: #111;
  }
`;

const TermsHeaderButton = styled(IconButton)`
  &.MuiButtonBase-root {
    padding: 0;
    color: #111;
  }
`;

const TermsContentBox = styled(Box)`
  background: #Ffffff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #E0E0E0;
  height: min(38vh, calc(100vh - 460px));
  min-height: 180px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 8px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #BDBDBD;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: #F5F5F5;
    border-radius: 4px;
  }
  & ul {
    list-style: disc;
    padding-left: 20px;
  }
`;

const GuardianConsentTerms = ({ intl, scrollPosition, onScrollEnd, isOver14 }) => {
  const termsBoxRef = useRef(null);
  const domain = `${window.location.protocol}//${window.location.host}`;
  const policyLanguage = intl.locale === "ko" ? "ko" : "en";
  const privacyPolicyUrl = `${domain}/policy/privacy/${policyLanguage}`;

  useEffect(() => {
    if (termsBoxRef.current && scrollPosition) {
      if (scrollPosition === 'top') {
        termsBoxRef.current.scrollTop = 0;
      }
    }
  }, [scrollPosition]);

  const handleScroll = (e) => {
    const element = e.target;
    const isScrollable = element.scrollHeight > element.clientHeight;
    
    if (!isScrollable) {
      onScrollEnd(true);
      return;
    }

    const isAtBottom = Math.abs(
      element.scrollHeight - element.clientHeight - element.scrollTop
    ) < 1;
    
    onScrollEnd(isAtBottom);
  };

  useEffect(() => {
    const element = termsBoxRef.current;
    if (element) {
      const isScrollable = element.scrollHeight > element.clientHeight;
      if (!isScrollable) {
        onScrollEnd(true);
      } else {
        onScrollEnd(false);
      }
    }
  }, []);

  const handleOpenPrivacyPolicy = () => {
    if (COMMON_UTIL.isWebView()) {
      callBrowser(privacyPolicyUrl);
      return;
    }

    window.open(privacyPolicyUrl, "_blank");
  };

  const detailTitleId = isOver14
    ? "guardian_consent_detail_title_over14"
    : "guardian_consent_detail_title";
  const detailTxt02Id = isOver14
    ? "guardian_consent_detail_txt02_over14"
    : "guardian_consent_detail_txt02";
  const detailTxt03Id = isOver14
    ? "guardian_consent_detail_txt03_over14"
    : "guardian_consent_detail_txt03";
  const detailTxt04Id = isOver14
    ? "guardian_consent_detail_txt04_over14"
    : "guardian_consent_detail_txt04";
  const detailTxt05Id = isOver14
    ? "guardian_consent_detail_txt05_over14"
    : "guardian_consent_detail_txt05";

  return (
    <TermsBox>
      <TermsHeader>
        <TermsHeaderTitle variant="body1">
          {intl.formatMessage({ id: "guardian_consent_detail" })} {/* [필수] 개인정보 수집·이용 동의 */}
        </TermsHeaderTitle>
        <TermsHeaderButton disableRipple onClick={handleOpenPrivacyPolicy} aria-label="privacy-policy">
          <ArrowRightIcon />
        </TermsHeaderButton>
      </TermsHeader>
      <TermsContentBox 
        ref={termsBoxRef}
        onScroll={handleScroll}
      >
        <Typography variant="body2" sx={{ mb: 1 }}>
            {intl.formatMessage({ id: detailTitleId })} {/* 연령 조건에 따라 문구 변경 */}
        </Typography>

        <Typography variant="body2" component="ul" sx={{ mb: 1 }}>
          <li>{intl.formatMessage({ id: detailTxt02Id })}</li> {/* 연령 조건에 따라 문구 변경 */}
          <li>{intl.formatMessage({ id: detailTxt03Id })}</li> {/* 연령 조건에 따라 문구 변경 */}
          <li>{intl.formatMessage({ id: detailTxt04Id })}</li> {/* 연령 조건에 따라 문구 변경 */}
        </Typography>

        <Typography variant="body2" sx={{mb: 1, mt: 3 }}>
          {intl.formatMessage({ id: detailTxt05Id })} {/* 연령 조건에 따라 문구 변경 */}
        </Typography>


      </TermsContentBox>
    </TermsBox>
  );
};

export default injectIntl(GuardianConsentTerms); 